const katakanaToHiragana = (str) => {
  return str ? str.replace(/[\u30a1-\u30f6]/g, (match) =>
    String.fromCharCode(match.charCodeAt(0) - 0x60)
  ) : '';
}


export const getRomanAlphabetString = (str) => {
  const hepburnMap = {
    きゃ: 'KYA', きゅ: 'KYU', きょ: 'KYO',
    しゃ: 'SHA', しゅ: 'SHU', しょ: 'SHO',
    ちゃ: 'CHA', ちゅ: 'CHU', ちょ: 'CHO',
    にゃ: 'NYA', にゅ: 'NYU', にょ: 'NYO',
    ひゃ: 'HYA', ひゅ: 'HYU', ひょ: 'HYO',
    みゃ: 'MYA', みゅ: 'MYU', みょ: 'MYO',
    りゃ: 'RYA', りゅ: 'RYU', りょ: 'RYO',
    ぎゃ: 'GYA', ぎゅ: 'GYU', ぎょ: 'GYO',
    じゃ: 'JA', じゅ: 'JU', じょ: 'JO',
    ぢゃ: 'JA', ぢゅ: 'JU', ぢょ: 'JO',
    びゃ: 'BYA', びゅ: 'BYU', びょ: 'BYO',
    ぴゃ: 'PYA', ぴゅ: 'PYU', ぴょ: 'PYO',
    ん: 'N', あ: 'A', い: 'I', う: 'U', え: 'E', お: 'O',
    か: 'KA', き: 'KI', く: 'KU', け: 'KE', こ: 'KO',
    さ: 'SA', し: 'SHI', す: 'SU', せ: 'SE', そ: 'SO',
    た: 'TA', ち: 'CHI', つ: 'TSU', て: 'TE', と: 'TO',
    な: 'NA', に: 'NI', ぬ: 'NU', ね: 'NE', の: 'NO',
    は: 'HA', ひ: 'HI', ふ: 'FU', へ: 'HE', ほ: 'HO',
    ま: 'MA', み: 'MI', む: 'MU', め: 'ME', も: 'MO',
    や: 'YA', ゆ: 'YU', よ: 'YO',
    ら: 'RA', り: 'RI', る: 'RU', れ: 'RE', ろ: 'RO',
    わ: 'WA', を: 'O',
    が: 'GA', ぎ: 'GI', ぐ: 'GU', げ: 'GE', ご: 'GO',
    ざ: 'ZA', じ: 'JI', ず: 'ZU', ぜ: 'ZE', ぞ: 'ZO',
    だ: 'DA', ぢ: 'JI', づ: 'ZU', で: 'DE', ど: 'DO',
    ば: 'BA', び: 'BI', ぶ: 'BU', べ: 'BE', ぼ: 'BO',
    ぱ: 'PA', ぴ: 'PI', ぷ: 'PU', ぺ: 'PE', ぽ: 'PO',
    っ: '',
    'ー': '',
    ゔぁ: 'BA', ゔぃ: 'BI', ゔ: 'BU', ゔぇ: 'BE', ゔぉ: 'BO',
    ゔゅ: 'BYU', ゔょ: 'BYO',
  };

  const hiragana = katakanaToHiragana(str);

  if (hiragana === '') {
    return '';
  }

  let result = '';
  let lastRoma = '';

  for (let i = 0; i < hiragana.length; i++) {
    const pair = hiragana.slice(i, i + 2);

    if (hepburnMap[pair]) {
      lastRoma = hepburnMap[pair];
      result += lastRoma;
      i++;
      continue;
    }

    const char = hiragana[i];

    if (char === 'っ') {
      const nextChar = hiragana[i + 1];
      const nextRoma = hepburnMap[nextChar] || '';
      result += nextRoma[0] || '';
      continue;
    }

    if (char === 'ー') {
      continue; // 長音すべて省略
    }

    if (char === 'ん') {
      const nextChar = hiragana[i + 1];
      const nextRoma = hepburnMap[nextChar] || '';
      result += /^[BMP]/.test(nextRoma) ? 'M' : 'N';
      continue;
    }

    lastRoma = hepburnMap[char] || '';
    result += lastRoma;
  }

  // 長音母音の例外処理
  result = result
    .replace(/UU/g, 'U')
    .replace(/OU/g, 'O')
    .replace(/OO/g, 'O');



  return result;
};